import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CampSiege3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CAMP_SIEGE3;
}

export default CampSiege3PoiTileEntity;
